import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { CustomQuestionsQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/QuestionnaireSectionProps";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";
import { values } from "lodash";

import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";

import * as questionIds from "../consultationQuestions/questionIds";
import { sections } from "../consultation";
// eslint-disable-next-line max-len
const HealthSurveillanceConsultationDrugAlcoholTestSectionUnconnected: React.FunctionComponent<CustomQuestionsQuestionnaireSectionProps> = (props: CustomQuestionsQuestionnaireSectionProps) => {
    const questions = values(props.questions || {});
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.DrugAlcoholTest}
        >
            {YesNoWithFollowUpQuestion({
                readonly: props.readonly,
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DrugAlcoholTestUnableToCarryOut),
                    getQuestionConfig(props.questionConfigs, questionIds.DrugAlcoholTestUnableToCarryOutReason)
                ],
                mandatory: true,
                followUpMandatory: true,
                questions: props.questions
            })}
            {getAnswerToQuestionWithId(questions, questionIds.DrugAlcoholTestUnableToCarryOut) !== MultiButtonQuestion.YesOption && <>
                <strong>Only complete this section if relevant</strong>
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.InstantSubstanceAbuseTest)}
                    mandatory
                />
                {
                    getAnswerToQuestionWithId(questions, questionIds.InstantSubstanceAbuseTest) === MultiButtonQuestion.YesOption &&
                    <>
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.InstantSubstanceAbuseTestResults)}
                            mandatory
                            values={[
                                "Negative",
                                "Non-Negative"
                            ]}
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.LabSubstanceAbuseTest)}
                            mandatory
                        />
                    </>
                }
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.AlcoholBreathTest)}
                    mandatory
                />
                {
                    getAnswerToQuestionWithId(questions, questionIds.AlcoholBreathTest) === MultiButtonQuestion.YesOption &&
                    <MultiButtonQuestion
                        readonly={props.readonly}
                        questionConfig={getQuestionConfig(props.questionConfigs, questionIds.AlcoholBreathTestResults)}
                        mandatory
                        values={[
                            "Negative",
                            "Non-Negative"
                        ]}
                    />
                }
            </>}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceConsultationDrugAlcoholTestSection = connect(makeMapStateToQuestionnaireSectionProps(sections.DrugAlcoholTest.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceConsultationDrugAlcoholTestSectionUnconnected);
